import { __decorate } from "tslib";
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { required, maxLength } from 'vuelidate/lib/validators';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import { validationMixin } from 'vuelidate';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import ActionButton from '@/components/action_button/Index.vue';
import Modal from '@/components/v3/Modal.vue';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
import PromptUpdaterMixin from '@/helpers/vue_mixins/v3/PromptUpdaterMixin';
import CreatePostMutation from '@/plugins/graphql/mutations/v3/facebook-create-page-post.gql';
let StoreLaunchCheckbox = class StoreLaunchCheckbox extends Mixins(Mixins(ViewportSizeMixin, AlertMixin, CleverTapEventsMixin, validationMixin, FormValidationsMixin), PromptUpdaterMixin) {
    constructor() {
        super(...arguments);
        this.isCreatingPost = false;
        this.postText = null;
    }
    onPromptChanged() {
        if (this.prompt) {
            this.postText = this.prompt.jsonCompletion.answer;
        }
    }
    get prompt() {
        if (Object.keys(this.$store.state.storeLaunchPrompt).length > 0) {
            return this.$store.state.storeLaunchPrompt;
        }
        return null;
    }
    redirectToStoreLaunchExplainer() {
        this.$router.push({ name: 'ecommerce-store-launch' });
    }
    createPost() {
        const self = this;
        this.$v.$touch();
        if (this.$v.$invalid) {
            return;
        }
        this.updateAction(this.prompt.uuid, 'accept');
        this.genAIAction('Store Launch', this.$store.state.appName, 'ACCEPT');
        this.isCreatingPost = true;
        return this.$apollo
            .mutate({
            mutation: CreatePostMutation,
            variables: {
                input: {
                    appUuid: this.$route.params.appUUID,
                    message: this.postText,
                    methodMessage: 'todo_list_share_button_message',
                },
            },
        })
            .then((result) => {
            this.isCreatingPost = false;
            const data = result.data.facebookCreatePagePost;
            if (data) {
                self.successNotification('Post successfully created.');
                this.$emit('refetchAppTask');
                this.$emit('showSurveyModal');
            }
        })
            .catch((e) => {
            this.isCreatingPost = false;
            self.errorNotification(e.message);
        });
    }
    mounted() {
        if (this.prompt) {
            this.postText = this.prompt.jsonCompletion.answer;
        }
    }
};
__decorate([
    Prop({ type: Object, default: null })
], StoreLaunchCheckbox.prototype, "task", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], StoreLaunchCheckbox.prototype, "progress", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], StoreLaunchCheckbox.prototype, "previewOnly", void 0);
__decorate([
    Watch('prompt')
], StoreLaunchCheckbox.prototype, "onPromptChanged", null);
StoreLaunchCheckbox = __decorate([
    Component({
        components: {
            ActionButton,
            Modal,
        },
        validations: {
            postText: {
                required,
                maxLength: maxLength(2000),
            },
        },
    })
], StoreLaunchCheckbox);
export default StoreLaunchCheckbox;
